import { GiCancel } from "react-icons/gi"
import { MenuContent, Pagination } from "../../styles/styles"
import { GoVerified } from "react-icons/go"

import './styles.css'

const InfoForm = ({ wasChanged, positionPagination, subtitle, title }) => {

    return (
        <MenuContent>
            <div>
                <p className="titlePagination">{title} {wasChanged ? <GoVerified size={20} color='green' /> : <GiCancel size={20} color='red' />}</p>
                <p className="subTitlePagination">{subtitle}</p>
            </div>
            <div className="paginationContainer">
                <Pagination>
                    Pág. {positionPagination}
                </Pagination>
            </div>
        </MenuContent>
    )
}

export default InfoForm